/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacyKit } from 'app/shared/model/pharmacy-kit.model';
import { IPharmacyStock } from 'app/shared/model/pharmacy-stock.model';
import { IPharmacyConsumableStock } from 'app/shared/model/pharmacy-consumable-stock.model';
import { IPharmacyImplantStock } from 'app/shared/model/pharmacy-implant-stock.model';

export interface IPharmacyKitItem {
  id?: string;
  quantity?: number;
  expectedQty?: number;
  active?: boolean;
  microSec?: number;
  lastupdated?: number;
  timestampentry?: number;
  cursor?: number;
  kit?: IPharmacyKit;
  drugStock?: IPharmacyStock | null;
  consumableStock?: IPharmacyConsumableStock | null;
  implantStock?: IPharmacyImplantStock | null;
}

export const defaultValue: Readonly<IPharmacyKitItem> = {
  active: false,
};
